import { isArray as e } from "./index575.js";
const o = (t) => e(t) ? t[0] : t, s = (t) => !t && t !== 0 ? [] : e(t) ? t : [t];
export {
  s as castArray,
  o as extractFirst
};
